/** Checks runtime support only; callers own whitespace normalization and length limits. */
export function isSupportedTimeZone(value) {
    try {
        new Intl.DateTimeFormat("en", { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}
